var m = require('mithril');

var layout = require('../layout/layout');
var modalForm = require('../layout/components/modalForm');
var networkOverviewPage = require('../network/components/networkOverviewPage');
var hostPage = require('../network/components/hostPage');
var devicePage = require('../network/components/devicePage');
var resourcePage = require('../network/components/resourcePage');

var cnipServer = modalForm(require('./models/cnipServer'));
var lontalkNetwork =  modalForm(require('./models/network'));
var lontalkChannel =  modalForm(require('./models/channel'));
var lontalkDevice =  modalForm(require('./models/device'));
var functionBlock = modalForm(require('./models/functionBlock'));
var networkVariable = modalForm(require('./models/networkVariable'));


var routes = {
  '/lontalk': {
    view: function() {
      return m(layout, m(networkOverviewPage,{form:cnipServer,activeTab:'Networks'}));
    }
  },
  '/lontalkcnip': {
    view: function() {
      return m(layout, m(networkOverviewPage,{form:cnipServer,activeTab:'Networks'}));
    }
  },
  '/lontalkcnip/:id': {
    view: function() {
      return m(layout, m(hostPage,{recordModel:cnipServer,form:lontalkNetwork,activeTab:'Networks'}));
    }
  },
  '/lontalknetwork/:id': {
    view: function() {
      return m(layout, m(devicePage,{recordModel:lontalkNetwork,form:lontalkChannel}));
    }
  },
  '/lontalkchannel/:id': {
    view: function() {
      return m(layout, m(devicePage,{recordModel:lontalkChannel,form:lontalkDevice}));
    }
  },
  '/lontalkdevice/:id': {
    view: function() {
      return m(layout, m(devicePage,{recordModel:lontalkDevice,form:functionBlock}));
    }
  },
  '/functionblock/:id': {
    view: function() {
      return m(layout, m(devicePage,{recordModel:functionBlock,form:networkVariable}));
    }
  },
  '/networkvariable/:id': {
    view: function() {
      return m(layout, m(resourcePage,{recordModel:networkVariable,activeTab:'Networks'}));
    }
  }
};

module.exports = routes;
